/**
 * Scales dimensions to fit within bounds while maintaining aspect ratio
 * @param maxWidth Maximum width in inches
 * @param maxHeight Maximum height in inches
 * @param aspectRatio Width/height ratio of the artwork
 * @returns Scaled dimensions that fit within bounds
 */
export function scaleToFitRatio(
  maxWidth: number,
  maxHeight: number,
  aspectRatio: number
): { width: number; height: number } {
  if (!maxWidth || !maxHeight || !aspectRatio) {
    throw new Error("Invalid dimensions or aspect ratio provided");
  }

  // Try scaling by width first
  const heightFromWidth = maxWidth / aspectRatio;

  if (heightFromWidth <= maxHeight) {
    // Width-constrained: the height fits within the max height
    return {
      width: Number(maxWidth.toFixed(2)),
      height: Number(heightFromWidth.toFixed(2))
    };
  }

  // Height-constrained: scale by height instead
  const widthFromHeight = maxHeight * aspectRatio;

  return {
    width: Number(widthFromHeight.toFixed(2)),
    height: Number(maxHeight.toFixed(2))
  };
}
